$(document).ready(function(){

$("img[src=\"//americantrench.com/cdn/shop/files/1_e9a57c7b-6e2f-46e8-96a9-e0db205715fc_x1000.png?v=1764780462\"]").attr("alt", "Man in blue jacket and plaid pants standing against green wall");
$("img[src=\"//americantrench.com/cdn/shopifycloud/storefront/assets/no-image-2048-a2addb12_x1000.gif\"]").attr("alt", "No image available");
$("img[src=\"//americantrench.com/cdn/shop/files/J.pressEDITORIAL-284_webhi_x1000.jpg?v=1749053037\"]").attr("alt", "Man wearing plaid shorts and white shirt");
$("img[src=\"//americantrench.com/cdn/shop/files/IMG_2971_x1000.jpg?v=1743739845\"]").attr("alt", "Man in beige shirt standing by desk");
$("img[src=\"//americantrench.com/cdn/shop/files/MG_9365_webhi_d98da51e-dc59-474f-a7ec-ff9690663ad5_x1000.jpg?v=1741290101\"]").attr("alt", "Person\'s legs wearing orange and white patterned socks");
$("img[src=\"//americantrench.com/cdn/shop/files/2_b029eb89-6545-47c1-b835-7e8cea33dc59_x1000.jpg?v=1740783536\"]").attr("alt", "Stack of patchwork sweatshirts on wooden stool");
$("img[src=\"//americantrench.com/cdn/shop/files/1_3cb1ae30-e2cf-4812-8285-29c2dc80eb5f_x1000.jpg?v=1764694367\"]").attr("alt", "Man in brown coat and sunglasses walking");
$("img[src=\"//americantrench.com/cdn/shop/files/73859_PSH_006_03_webhi_e6182c2b-d231-4eaa-a460-77d7b415d994_x1000.jpg?v=1764694476\"]").attr("alt", "Man leaning on tree in forest, wearing white sweatshirt and green shorts");
$("img[src=\"//americantrench.com/cdn/shop/files/29450018_webhi_x1000.jpg?v=1706024857\"]").attr("alt", "Brown and blue plaid shirt with buttons");
$("img[src=\"//americantrench.com/cdn/shop/files/SS24Main-6_webhi_x1000.jpg?v=1762135318\"]").attr("alt", "Man in beige outfit standing by pool edge outdoors");

$('a.velaIonTopLinks[href="#velaTopLinks"]').attr({
    
    'aria-label': 'Open main menu'
    
});

    $(".velaSwatchProduct label").each(function () {
    var $label = $(this);
    var style = $label.attr("style") || "";
    var color = "";

    // Extract background-color
    var bgMatch = style.match(/background-color:\s*([^;]+)/i);

    if (bgMatch) {
        var bgColor = bgMatch[1].trim().toLowerCase();

        // Ignore transparent/inherit/initial if desired
        if (
            bgColor &&
            bgColor !== "transparent" &&
            bgColor !== "inherit" &&
            bgColor !== "initial"
        ) {
            color = bgColor;
        }
    }

    // If no usable background-color, extract from image filename
    if (!color) {
        var urlMatch = style.match(/url\((['"]?)(.*?)\1\)/i);

        if (urlMatch) {
            var filename = urlMatch[2]
                .split("/")
                .pop()
                .split("?")[0]
                .replace(/\.[^.]+$/, "");

            filename = filename
    .replace(/_small|_medium|_large|_webhi|_web|_thumbnail|_thumb/gi, "")
    .replace(/flat/gi, "") // Remove "flat" whether attached or separate
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([a-z]+)(blue|black|white|grey|gray|green|red|pink|brown|tan|navy|olive|gold|silver|beige|orange|purple|yellow)$/i, "$1 $2")
    .replace(/[_-]+/g, " ")
    .trim();
            color = filename.replace(/[_-]+/g, " ").trim();
        }
    }

    if (color) {
        color = color.replace(/\b\w/g, function (c) {
            return c.toUpperCase();
        });

        $label.attr("aria-label", " Select "+color+ " color");
    }
});

$(".velaSwatchCus .velaSwatchProduct li").each(function () {
    var $label = $(this).find("label");
    var label = $label.attr("aria-label");

    if (label) {
        $(this)
            .find(".hidden a:empty")
            .attr("aria-label", label.replace(/^Select/i, "View larger image of product in"));
    }
});
$('a.velaLogoLink[href="/"]').attr(
    'aria-label',
    "American Trench logo, trademark, Made in the USA apparel"
);
$("h2:empty").append("<span style='display:none'>.</span>");
$("h1:empty").append("<span style='display:none'>.</span>");
$("h1>span>b").append("<span style='display:none'>.</span>");
$("h1.mobile-text.text-white").append("<span style='display:none'>.</span>");
$(".velaSearch.form-control").attr("aria-label", "Search products");
setTimeout(() => {

    $('.rs-text-widget__link').each(function () {
        var visibleText = $(this).text().replace(/\s+/g, ' ').trim();
        $(this).attr('aria-label', visibleText);
    });
  $('img[data-srcset*="web_footer_"]').attr("alt", "American Trench logo and OE certification logo"); 
  $('a.btnClose[href="#velaTopLinks"]').attr("aria-label", "Close navigation menu");
$('a.btnClose[href="#velaSearchTop"]').attr("aria-label", "Close search");
$(".keen-slider__slide .pdp-slide-inner img:not([alt]), .keen-slider__slide .pdp-slide-inner img[alt='']").attr("alt", $("h3").first().text().trim());
$("div.product-upsells .velaProBlock").each(function () {
    var href = $(this).find("a[href]").attr("href");
    if (!href) return;

    var alt = href.split("/products/")[1]
        .split("?")[0]
        .replace(/-/g, " ")
        .replace(/\b\w/g, function (c) {
            return c.toUpperCase();
        });

    $(this).find("img.imgFlyCart:not([alt]), img.imgFlyCart[alt='']").attr("alt", alt);
});
$('a[href="/products/lucky-grab-bag-3-pack"]').attr("aria-label", "Lucky Grab Bag 3 Pack");



$("img[src='//americantrench.com/cdn/shop/files/IMG_9673_webhi_1000x.jpg?v=1775835291']").attr("alt", "Orig. Equip. camouflage mesh shorts displayed on rocks");
}, 1000);
$("img[src='//americantrench.com/cdn/shop/files/IMG_9673_webhi_x1000.jpg?v=1775835291']").attr("alt", "Orig. Equip. camouflage mesh shorts displayed on rocks");
$(".slider-btn").eq(0).attr("aria-label", "Previous slide").end().eq(1).attr("aria-label", "Next slide");


$("#shopify-section-component_press_YJtrkJ .slider-btn").each(function () {
    $(this).attr("aria-label", $(this).hasClass("-scale-x-100") ? "Previous featured publications" : "Next featured publications");
});


$("img[src='//americantrench.com/cdn/shop/files/IMG_9673_webhi_1000x.jpg?v=1775835291']").attr("alt", "Orig. Equip. camouflage mesh shorts displayed on rocks");
$('img[src*="Asset_5.svg"]').attr("alt", "American Trench logo");

$("h3>br:empty").append("<span style='display:none'>.</span>");
$('a[href="https://www.ftc.gov/business-guidance/advertising-marketing/made-in-usa"]').attr("aria-label", "Learn about FTC Made in USA standards");
$("img[src*='gift-card-preview.png']").attr("alt", "American Trench gift card");
$('a[href="/products/philly-special-kennedy-socks-1"] ').attr("aria-label", "Philly Special Kennedy Socks");
 $("img[src=\"//americantrench.com/cdn/shop/files/gq_4cd752ca-362f-4bef-9a08-1ba35905b75e_500x.png?v=1721054672\"]").attr("alt", "GQ logo");
    $("img[src=\"//americantrench.com/cdn/shop/files/gp_76969536-f82e-479d-9aa1-660afe294d2a_500x.png?v=1724096371\"]").attr("alt", "Gear Patrol logo ");
    $("img[src=\"//americantrench.com/cdn/shop/files/The_New_York_Times_logo_500x.png?v=1750780923\"]").attr("alt", "The New York Times logo");
    $("img[src=\"//americantrench.com/cdn/shop/files/Wirecutter_500x.png?v=1750780783\"]").attr("alt", "Wirecutter logo");
    $("img[src=\"//americantrench.com/cdn/shop/files/strat_500x.png?v=1721054711\"]").attr("alt", "The Strategist logo");
    $("img[src=\"//americantrench.com/cdn/shop/files/valet_500x.png?v=1721054736\"]").attr("alt", "Valet logo ");
    $("img[src=\"//americantrench.com/cdn/shop/files/nyp_0e7d33bf-0a71-4148-bc45-dceec8c207db_500x.png?v=1724096395\"]").attr("alt", "New York Post logo");
     $("img[src=\"//americantrench.com/cdn/shop/files/wsj_c04c688c-f483-4e69-a268-fd51debcf3ad_500x.png?v=1724096384\"]").attr("alt", "WSJ logo");

     $(".velaProBlock").each(function () {
    var altText = $.trim($(this).find(".proName a").text());

    if (altText) {
        $(this)
            .find("img")
            .filter(function () {
                return !$(this).attr("alt") || $.trim($(this).attr("alt")) === "";
            })
            .attr("alt", altText);
    }
});

$("tbody>tr>th:empty").append("<span style='display:none'>.</span>")
  $('input[type="email"]').attr('aria-label', 'Enter your email');
  $('button.rez-notify-close-btn').attr('aria-label', 'Close Notify Me dialog');
  $("img[src='//americantrench.com/cdn/shop/files/kyle_studio_38.jpg?v=1782252997']").attr("alt", "Person wearing American Trench apparel in a studio");  
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
 

  console.log("ready");
});